import { Injectable } from '@angular/core';
import { DynamicCrudSelectComponent } from 'src/app/___COMPONENTS/__crud/dynamic-crud-select/dynamic-crud-select.component';
import { DynamicDatePickerComponent } from 'src/app/___COMPONENTS/__crud/dynamic-date-picker/dynamic-date-picker.component';
import { DynamicInputComponent } from 'src/app/___COMPONENTS/__crud/dynamic-input/dynamic-input.component';
import { DynamicTextareaComponent } from 'src/app/___COMPONENTS/__crud/dynamic-textarea/dynamic-textarea.component';
import { DynamicSlideToggleComponent } from 'src/app/___COMPONENTS/dynamic-slide-toggle/dynamic-slide-toggle.component';
import { CrudFieldItemService } from './crud-field-item.service';

@Injectable({
  providedIn: 'root'
})
export class CrudFieldsService {

  currentCrudId;
  newObject = null;
  
  constructor() { }

  getDynamicContent(sectionContent){
    return new CrudFieldItemService(DynamicInputComponent, {data: 'test123'});
  }

  getInputFormField(fieldName, value) {
    return new CrudFieldItemService(DynamicInputComponent, {
      fieldName: fieldName,
      value: value,
      crudId: this.currentCrudId
    });
  }

  getMatSelectFormField(fieldName, value){
    return new CrudFieldItemService(DynamicCrudSelectComponent, {
      fieldName: fieldName,
      value: value,
      crudId: this.currentCrudId
    });
  }

  getTextAreaFormField(fieldName, value) {
    return new CrudFieldItemService(DynamicTextareaComponent, {
      fieldName: fieldName,
      value: value,
      crudId: this.currentCrudId
    });
  }

  generateBooleanFormField(fieldName, value) {
    return new CrudFieldItemService(DynamicSlideToggleComponent, {
      fieldName: fieldName,
      value: value,
      crudId: this.currentCrudId
    });
  }

  generateDatePicker(fieldName, value) {
    return new CrudFieldItemService(DynamicDatePickerComponent, {
      fieldName: fieldName,
      value: value,
      crudId: this.currentCrudId
    });
  }

  saveFieldValue(field, value) {
    this.newObject[field] = value;
  }

  getDefaultEmptyComponent(){
    // TO DO (change this default)
    return new CrudFieldItemService(DynamicSlideToggleComponent, {title: 'DEFAULT COMPONENT'});
  }

  getHtmlComponentFromProp(dataType: string, fieldName: string, value: any, crudId: string) {
    this.currentCrudId = crudId;
    switch (dataType) {
      case 'int':
        // if is ID return no component, since the value cannot be edited
        if (fieldName === 'id'){
          return null;
        }else{
          if (fieldName.substring(0, 5) === 'FK_ID'){
            return this.getMatSelectFormField(fieldName, value);
          }else{
            return this.getInputFormField(fieldName, value);
          }
        }
      case 'varchar':
        return this.getInputFormField(fieldName, value);
      case 'text':
        return this.getTextAreaFormField(fieldName, value);
      case 'tinyint':
        return this.generateBooleanFormField(fieldName, value);
      case 'date':
      case 'datetime':
        return this.generateDatePicker(fieldName, value);
      default:
        return this.getInputFormField(fieldName, value);
      }
  }

}